import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const UploadingSkeleton = () => {
  return (
    <div className="h-full min-w-[300px]">
      <div className="flex flex-col p-4 pb-0 h-[calc(100vh_-_70px)]">
        <div className="p-4 rounded-lg mb-2 bg-white">
          <div className="flex flex-col items-center">
            <Skeleton circle height={68} width={68} className="mb-4" />
            <Skeleton height={24} width={192} className="mb-2" />
            <Skeleton height={16} width={128} />
          </div>
        </div>

        <div className="flex flex-col bg-white rounded-lg p-4 max-h-[calc(100%_-_220px)] overflow-y-auto">
          <ul className="space-y-2">
            {[1, 2].map((i) => (
              <li key={`folder-${i}`}>
                <div className="flex border-2 border-gray-200 rounded-md justify-between p-2">
                  <div className="flex items-center">
                    <Skeleton width={20} height={20} className="mr-2" />
                    <Skeleton width={96} height={16} />
                  </div>
                  <Skeleton width={20} height={20} />
                </div>
              </li>
            ))}

            {[1, 2, 3].map((i) => (
              <li key={`file-${i}`} className="mb-1">
                <div className="flex border-2 border-gray-200 rounded-md justify-between p-2">
                  <div className="flex items-center max-w-[90%]">
                    <Skeleton width={128} height={16} className="mr-2" />
                    <Skeleton width={48} height={12} />
                  </div>
                  <Skeleton width={20} height={20} />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <footer className="absolute flex justify-end bottom-0 bg-white w-full rounded-t-3xl h-[60px]">
        <div className="flex p-2 space-x-2">
          <Skeleton width={80} height={40} />
          <Skeleton width={96} height={40} />
        </div>
      </footer>
    </div>
  )
}

export default UploadingSkeleton
